import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { PaymentType } from "../../../../../../../../Wrap/Constants/Enums/Apply/PaymentType";
import { DisinvestmentStrategyType } from "../../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { PaymentPayer } from "../../../../../../../../Wrap/Constants/Enums/Payments/PaymentPayer";
import { TransferStatus } from "../../../../../../../../Wrap/Constants/Enums/Transfer/TransferStatus";

export const DisinvestmentTipMsg =
    "Editing Auto-disinvestment strategy here, will apply these changes at account level.";

export const PaymentPayerMapper = {
    [PaymentPayer.NotSpecified]: "Not Specified",
    [PaymentPayer.Client]: "Client",
    [PaymentPayer.ThirdParty]: "Third Party",
    [PaymentPayer.Employer]: "Employer",
};

export const PaymentTypeMapper = {
    [PaymentType.Single]: "Single",
    [PaymentType.Regular]: "Regular",
};

export const TransferStatusMapper = {
    [TransferStatus.NotSpecified]: "Not Specified",
    [TransferStatus.Pending]: "Pending",
    [TransferStatus.Completed]: "Completed",
};

export const DisinvestmentStrategyTypeMap = {
    [DisinvestmentStrategyType.LVS]: "Least Volatile Stock (LVS)",
    [DisinvestmentStrategyType.Lifo]: "Last In, First Out (LiFo)",
    [DisinvestmentStrategyType.Proportional]: "Proportional",
};
